export const url_header = "http://13.233.165.1/";
export const register_redirect_url = "http://13.233.165.1/register/complete";
